<template>
  <section>
    <ChartDonutCountry
      v-if="which === 1"
      v-bind="{ nums, abbr, dark }"
      class="chart-donut"
    />
    <ChartDonutCountry
      v-if="which === 2"
      v-bind="{ nums, abbr, dark, which }"
      class="chart-donut mx-auto"
    />
    <legend>
      <ul v-if="which === 1">
        <template v-if="abbr === 'IN'">
          <li title="Chrome">{{ nums.data[0] }}%</li>
          <li title="Other">{{ nums.data[1] }}%</li>
          <li title="Safari">{{ nums.data[2] }}%</li>
        </template>
        <template v-else>
          <li title="Chrome">{{ nums.data[0] }}%</li>
          <li title="Safari">{{ nums.data[2] }}%</li>
          <li title="Other">{{ nums.data[1] }}%</li>
        </template>
      </ul>
      <ul v-if="which === 2" class="secondary">
        <template v-if="abbr === 'CA'">
          <li title="Firefox">{{ nums.data[0] }}%</li>
          <li title="Edge">{{ nums.data[4] }}%</li>
          <li title="IE">{{ nums.data[3] }}%</li>
          <li title="Opera">{{ nums.data[1] }}%</li>
          <li title="Other">{{ nums.data[2] }}%</li>
        </template>
        <template v-else-if="abbr === 'NO'">
          <li title="Firefox">{{ nums.data[4] }}%</li>
          <li title="Edge">{{ nums.data[3] }}%</li>
          <li title="IE">{{ nums.data[2] }}%</li>
          <li title="Opera Mini" class="browser-operamini">{{ nums.data[0] }}%</li>
          <li title="Other">{{ nums.data[1] }}%</li>
        </template>
        <template v-else>
          <li title="Firefox">{{ nums.data[0] }}%</li>
          <li title="Edge">{{ nums.data[4] }}%</li>
          <li title="IE">{{ nums.data[3] }}%</li>
          <li title="Opera">{{ nums.data[2] }}%</li>
          <li title="Other">{{ nums.data[1] }}%</li>
        </template>
      </ul>
    </legend>
  </section>
</template>

<script>
import ChartDonutCountry from "./donut-country.vue";

export default {
  components: { ChartDonutCountry },
  props: {
    nums: {
      type: [Object, Array],
      default: () => {
        return {};
      }
    },
    abbr: {
      type: String,
      default: "XX"
    },
    dark: {
      type: Boolean,
      default: false
    },
    which: {
      type: Number,
      default: 1
    }
  }
};
</script>

<style lang="scss" scoped>
legend {
  font-size: 1em;
  display: flex;
  justify-content: center;
  ul {
    list-style: none;
    padding: 0;
    display: block;
    /* width: 50%; */
    margin: 0.5em auto;
    li {
      text-align: left;
      font-weight: bold;
      &:before {
        $dim: 8px;
        width: $dim;
        height: $dim;
        display: inline-block;
        content: " ";
        margin-right: 4px;
      }
      &:nth-of-type(1) {
        &:before {
          background: $blue;
        }
      }
      &:nth-of-type(2) {
        &:before {
          background: $gold;
        }
      }
      &:nth-of-type(3) {
        &:before {
          background: $lightgrey2;
        }
      }
    }
    &.secondary {
      li {
        &:nth-of-type(1) {
          &:before {
            background: $blue;
          }
        }
        &:nth-of-type(2) {
          &:before {
            background: $blue2;
          }
        }
        &:nth-of-type(3) {
          &:before {
            background: $orange;
          }
        }
        &:nth-of-type(4) {
          &:before {
            background: $yellow;
          }
        }
        &.browser-operamini {
          &:before {
            background: $gold;
          }
        }
        &:nth-of-type(5) {
          &:before {
            background: white;
          }
        }
      }
    }
  }
}
</style>
